<template>
  <div class="multi-select">
    <div class="title-input">
      <div class="title" v-if="title">{{title}}</div>
      <div class="input-container">
        <input 
          ref="input" 
          type="text" 
          :placeholder="'搜索主题'" 
          v-model.trim="searchText" 
          @input="onInputSearch" 
        />
        <el-button class="search-button"><i class="icon-search"></i></el-button>
      </div>
    </div>
    <div v-show="inputFilterList.length">
      <ul class="list">
        <li class="item" :class="{active:selectedList.indexOf(item) > -1}" v-for="(item, idx) in inputFilterList" :key="idx" @click="handleItemClick(item)">{{item.name}}</li>
      </ul>
      <div v-if="showThemeBtn&&!showMoreTheme" class="check-more-btn industry-btn" @click="ToShowMore()"><div class="check-more-img"></div></div>
      <div v-if="showThemeBtn&&showMoreTheme" class="check-more-btn industry-btn" @click="ToShowMore()"><div class="check-more-img-reverse"></div></div>
    </div>
    <div class="empty-list" v-show="!inputFilterList.length">“暂无相关主题，请试试搜新闻”</div>
  </div>
</template>
<script> 
/*
  props: 

  title: 选项标题
  items: 是数组类型，包含所有选项

  事件:

  change 参数：包含所有选中的条目
  
*/

export default {
  data() {
    return {
      selectedList: [],
      showMoreTheme: false,
      showThemeBtn: false,
      multiSelectElement: null,
      multiSelectElementHeight: 0,
      searchText: '',
      timer: null,
      inputFilterList: []
    };
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    items: {
      type: Array
    },
    selectedFilters: {
      type: Array
    }
  },
  watch: {
    'selectedFilters'(newval) {
      this.selectedList = newval;
    }
  },
  methods: {
    onInputSearch() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.inputFilterList = this.items.filter(item => {
          return item.name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1;
        });
      }, 600);
    },
    ToShowMore() {
      this.showMoreTheme = !this.showMoreTheme;
      if (!this.showMoreTheme) {
        this.multiSelectElement.style.height = '34px';
        this.multiSelectElement.style.overflow = 'hidden';
        this.multiSelectElement.style.transition = 'all .3s ease-in';
      } else if (this.showMoreTheme && this.multiSelectElementHeight === 102) {
        this.multiSelectElement.style.height = '102px';
        this.multiSelectElement.style.overflow = 'auto';
        this.multiSelectElement.style.transition = 'all .3s ease-in';
      } else if (this.showMoreTheme && this.multiSelectElementHeight > 102) {
        this.multiSelectElement.style.height = '120px';
        this.multiSelectElement.style.overflow = 'auto';
        this.multiSelectElement.style.transition = 'all .3s ease-in';
      } else if (this.showMoreTheme && this.multiSelectElementHeight > 34 && this.multiSelectElementHeight < 102) {
        this.multiSelectElement.style.height = '68px';
        this.multiSelectElement.style.overflow = 'auto';
        this.multiSelectElement.style.transition = 'all .3s ease-in';
      } 
    },
    handleItemClick(item) {
      if (this.selectedList.indexOf(item) === -1) {
        this.selectedList.push(item);
      } else {
        this.selectedList.splice(this.selectedList.indexOf(item), 1);
      }
      this.$emit('change', this.selectedList);
    }
  },
  mounted() {
    this.inputFilterList = JSON.parse(JSON.stringify(this.items));
    this.selectedList = this.selectedFilters;
    this.multiSelectElement = document.querySelector('.list');
    this.$nextTick(() => {
      this.multiSelectElementHeight = document.querySelector('.list').clientHeight;
      if (this.multiSelectElementHeight > 34) {
        this.showThemeBtn = true;
        this.multiSelectElement.style.height = '34px';
        this.multiSelectElement.style.overflow = 'hidden';
      } else {
        this.showThemeBtn = false;
        this.multiSelectElement.style.height = '34px';
        this.multiSelectElement.style.overflow = 'hidden';
      }
    });
  }
};
</script>
<style lang="scss" scoped>
ul, li {
  margin: 0;
  padding: 0;  
  list-style: none;
}
.multi-select {
  padding: 0 11px;
  // display: flex;
  width: 100%;
  // height: 100px;
  // overflow: auto;
  // height: 34px;
  // overflow: hidden;
}
  .check-more-btn {
    position: absolute;
    right: 16px;
    width: 24px;
    height: 24px;
    padding: 4px;
    background-color: #ffffff;
    border-radius: 4px;
    cursor: pointer;
    .check-more-img {
      width: 16px;
      height: 16px;
      background: url("../../assets/img/down-arrow1.svg") no-repeat;
      background-size: cover;
    }
    .check-more-img-reverse {
      width: 16px;
      height: 16px;
      background: url("../../assets/img/up-arrow1.svg") no-repeat;
      background-size: cover;
    }
  }
  .industry-btn {
    top: 52px;
  }
  .title {
    position: absolute;
    top: 12px;
    min-width: 44px;
    height: 32px;
    line-height: 32px;
    align-items: center;
    // padding-right: 0 8px;
    font-weight: 600;
    font-size: 14px;
    color: #464d6c;
  }
  .input-container {
    position: relative;
    width: 271px;
    margin-bottom: 5px;
    margin-left: 44px;
    input {
      width: 100%;
      height: 26px;
      // margin-top: -6px;
      padding: 10px 50px 10px 12px;
      font-size: 14px;
      border: solid 1px #e5e6ee !important;
      border-radius: 2px;
      background-color: #ffffff;
      outline: none;
      &:hover {
        border: 1px solid #d1d2da !important;
      }
      &:focus {
        border: 1px solid #747990 !important;
      }
    }
    input::-webkit-input-placeholder{
      color: #9ea1b4;
    }
    input::-moz-placeholder{   /* Mozilla Firefox 19+ */
      color: #9ea1b4;
    }
    input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
      color: #9ea1b4;
    }
    input:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
      color: #9ea1b4;
    }

    .search-button { 
      position: absolute;
      top: 5px;
      right: 2px;  
      padding: 0px 12px;
      width: 46px;
      // background-color: #666;
      background-color: #ffffff;
      border: none;
      cursor: auto;
      span {
        display: block;
      }

      .icon-search {
        display: inline-block;
        width: 14px;
        height: 14px;
        background-image: url('../../assets/img/search3.svg');
        background-size: 100% 100%;
      }
    }
  } 
  .empty-list {
    margin-left: 44px;
    height: 34px;
    line-height: 34px;
    color: #9ea1b4;
    font-size: 14px;
  }
  ul.list {
    display: flex;
    flex-flow: row;
    flex-wrap: wrap;
    width: 1045px;
    margin-left: 44px;
    .item {
      height: 24px;
      margin: 5px 10px 5px 0;
      padding: 2px 4px;
      font-size: 14px;
      color: #464d6c;
      border-radius: 2px;
      cursor: pointer;
      &:hover {
        color: #45a8cc !important;
        background-color: #ffffff;
        border-radius: 2px;
        cursor: pointer;
      }
    }
  }
</style>
